// noinspection DuplicatedCode

import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { alertService } from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
  getKlien,
  insertKlien,
  insertUserClient,
  klienSelector,
  updateKlien,
} from "./klienSlice";

import { Colors } from "../../../assets/Colors";
import KlienCqEditor, { cleanCq, validateCq } from "./KlienCqEditor";

const KlienPage = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(5);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [insertFetch, setInsertFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [showModalCreateAccount, setModalCreateAccount] = useState(false);
  const [showModalResetAccount, setModalResetAccount] = useState(false);

  const [cqRows, setCqRows] = useState([]);

  const klien = useSelector(klienSelector);

  // Kolom "CQ" di tabel: nama CQ aktif (kode bila nama kosong), dipisah koma.
  const tableData = useMemo(
    () =>
      (klien.data || []).map((k) => ({
        ...k,
        DaftarCQ:
          (k.CQ || [])
            .filter((c) => Number(c.Status) !== 0)
            .map((c) => c.NamaCQ || c.KodeCQ)
            .join(", ") || "-",
      })),
    [klien.data]
  );

  // Isi editor CQ tiap kali modal Tambah/Ubah dibuka.
  useEffect(() => {
    if (showModalAdd) setCqRows([]);
  }, [showModalAdd]);
  useEffect(() => {
    if (showModalEdit) setCqRows((currentData.CQ || []).map((c) => ({ ...c })));
  }, [showModalEdit, currentData]);

  // Mengembalikan daftar CQ siap kirim, atau null bila tak valid.
  function cqForSubmit() {
    const rows = cleanCq(cqRows);
    const err = validateCq(rows);
    if (err) {
      alertService.error(err + " — data tidak disimpan.", {
        autoClose: true,
        keepAfterRouteChange: false,
      });
      return null;
    }
    return rows;
  }

  function alertIfRejected(res) {
    if (res?.meta?.requestStatus === "rejected") {
      alertService.error(res.payload?.message || "Gagal menyimpan customer", {
        autoClose: false,
        keepAfterRouteChange: false,
      });
    }
  }

  useEffect(() => {
    dispatch(
      getKlien({
        start: start,
        count: count,
        search: "",
      })
    );
  }, []);

  useEffect(() => {
    if (search !== "" && klien.isGetSuccess && !klien.isGetFetching) {
      let calc = klien?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = klien.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    } else if (search === "" && klien.isGetSuccess && !klien.isGetFetching) {
      let calc = klien?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = klien.data ? Math.ceil(calc / count) : 1;
      setSearchFetch(false);
      setMaxPage(tempMaxPage);
    }

    if (
      !klien?.isGetFetching &&
      klien.isGetSuccess &&
      maxPage === 0 &&
      firstLoading === false
    ) {
      let calc = klien?.count - 1;
      if (calc === 0) {
        calc = 1;
      }

      if (calc % count === 0) {
        calc = calc + 1;
      }
      let tempMaxPage = klien.data ? Math.ceil(calc / count) : 1;
      setMaxPage(tempMaxPage);
      setFirstLoading(true);
      dispatch(
        getKlien({
          start: start,
          count: count,
          search: search,
        })
      );
    }

    if (insertFetch) {
      setInsertFetch(false);
      if (klien.isGetSuccess) {
        alertService.success(klien.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        dispatch(
          getKlien({
            start: start,
            count: count,
            search: search,
          })
        );
      }
    }

    if (updateFetch) {
      setUpdateFetch(false);
      if (klien.isUpdateSuccess) {
        alertService.success(klien.message, {
          autoClose: true,
          keepAfterRouteChange: false,
        });
        dispatch(
          updateKlien({
            start: start,
            count: count,
            search: search,
          })
        );
      }
    }
  });

  // function handleGetKlien(params) {
  //   return dispatch(getKlien(params));
  // }

  function handleInsertKlien(param) {
    const cq = cqForSubmit();
    if (!cq) return;
    setInsertFetch(true);
    const params = {
      DetailAccountID: param.dropdownDetailAccountValue,
      NamaKlien: param.inputOneValue,
      Kontak: param.inputTwoValue,
      Jabatan: param.inputThreeValue,
      NoTlpn: param.inputFourValue,
      Alamat: param.inputFiveValue,
      NPWP: param.inputSixValue,
      AlamatNPWP: param.inputSevenValue,
      Catatan: param.inputEightValue,
      CQ: cq,
    };

    dispatch(insertKlien(params)).then(alertIfRejected);
  }

  function handleUpdateKlien(param) {
    const cq = cqForSubmit();
    if (!cq) return;
    setUpdateFetch(true);

    const params = {
      DetailAccountID: param.dropdownDetailAccountValue,
      NamaKlien: param.inputOneValue,
      Kontak: param.inputTwoValue,
      Jabatan: param.inputThreeValue,
      NoTlpn: param.inputFourValue,
      Alamat: param.inputFiveValue,
      NPWP: param.inputSixValue,
      AlamatNPWP: param.inputSevenValue,
      Catatan: param.inputEightValue,
      KlienID: currentData.KlienID,
      status: param.status,
      CQ: cq,
    };
    dispatch(updateKlien(params)).then(alertIfRejected);
  }

  function handleBuatAkunKlien(param) {
    setUpdateFetch(true);

    const params = {
      Nik: currentData.KlienID,
      Username: param.inputOneValue,
    };

    dispatch(insertUserClient(params));
  }

  function handleSearch(searchValue) {
    let params = {
      start: 0,
      count: 5,
      search: searchValue,
    };
    dispatch(getKlien(params));

    setStart(0);
    setCount(5);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    let params = {
      start: newStart,
      count: count,
      search: search,
    };
    dispatch(getKlien(params));

    setPage(newPage);
    setStart(newStart);
  }

  function handleUpdateCount(newCount) {
    let calc = klien.count - 1;
    if (calc === 0) {
      calc = 1;
    }

    let params = {
      start: newCount === "-1" ? 0 : start,
      count: newCount === "-1" ? klien.count : newCount,
      search: search,
    };
    dispatch(getKlien(params));

    setPage(1);
    setCount(newCount === "-1" ? klien.count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
    setModalCreateAccount(status.showModalCreateAccount);
  }

  if (!firstLoading) {
    return <div>loading</div>;
  } else {
    return (
      <>
        <div className="md:ml-64">
          <div
            style={{ background: Colors.primary }}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
          >
            <div className="container mx-auto max-w-full">
              <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
          </div>

          <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
              <div className="grid grid-cols-1 px-4">
                <TableCard
                  backButton={true}
                  backUrl={"master"}
                  handleSearch={handleSearch}
                  searchPlaceholder="Klien"
                  updatePage={handleUpdatePage}
                  updateCount={handleUpdateCount}
                  currentData={handleCurrentData}
                  currentPage={page}
                  maxPage={maxPage}
                  tableTitle="Master Klien"
                  tableData={tableData}
                  colOneTitle="ID"
                  colOneData="KlienID"
                  colTwoTitle="Nama Customer"
                  colTwoData="NamaKlien"
                  status="Status"
                  colThreeTitle="Kontak"
                  colThreeData="Kontak"
                  colFourTitle="Username"
                  colFourData="Username"
                  colFiveTitle="CQ"
                  colFiveData="DaftarCQ"
                  fetching={klien.isGetFetching}
                  modal={handleModal}
                  editEnabled={true}
                  akunUser="Username"
                />
              </div>
            </div>
          </div>
        </div>
        {showModalAdd && (
          <ModalForm
            showModal={showModalAdd}
            addEnabled={true}
            modal={handleModal}
            modalTitle="Tambah Customer"
            dropdownDetailAccount={true}
            inputOneTitle="Nama Customer"
            inputTwoTitle="Kontak"
            inputThreeTitle="Jabatan"
            inputFourTitle="Nomor Telepon"
            inputFourType="number"
            inputFiveTitle="Alamat"
            inputSixTitle="NPWP"
            inputSevenTitle="Alamat NPWP"
            inputEightTitle="Catatan"
            extraContent={<KlienCqEditor rows={cqRows} setRows={setCqRows} />}
            submitButtonTitle="Submit"
            handleSubmit={handleInsertKlien}
          />
        )}
        {showModalEdit && (
          <ModalForm
            showModal={showModalEdit}
            editEnabled={true}
            id={currentData.KlienID}
            modal={handleModal}
            modalTitle="Ubah Customer"
            dropdownDetailAccount={true}
            dropdownDetailAccountValue={currentData.DetailAccountID}
            inputOneTitle="Nama Customer"
            inputOneValue={currentData.NamaKlien}
            inputTwoTitle="Kontak"
            inputTwoValue={currentData.Kontak}
            inputThreeTitle="Jabatan"
            inputThreeValue={currentData.Jabatan}
            inputFourTitle="Nomor Telepon"
            inputFourValue={currentData.NoTlpn}
            inputFourType="number"
            inputFiveTitle="Alamat"
            inputFiveValue={currentData.Alamat}
            inputSixTitle="NPWP"
            inputSixValue={currentData.NPWP}
            inputSevenTitle="Alamat NPWP"
            inputSevenValue={currentData.AlamatNPWP}
            inputEightTitle="Catatan"
            inputEightValue={currentData.Catatan}
            extraContent={<KlienCqEditor rows={cqRows} setRows={setCqRows} />}
            status={currentData.Status}
            submitButtonTitle="Submit"
            handleSubmit={handleUpdateKlien}
          />
        )}
        {showModalCreateAccount && (
          <ModalForm
            showModal={showModalCreateAccount}
            editEnabled={false}
            id={currentData.KlienID}
            modal={handleModal}
            modalTitle="Buat Akun Klien"
            inputOneTitle="Username"
            inputOneValue=""
            submitButtonTitle="Buat"
            handleSubmit={handleBuatAkunKlien}
            alertEnable={true}
            alertValue="Password akan sama dengan username!"
          />
        )}
      </>
    );
  }
};

export default KlienPage;
